import {handleRequiredError} from '../../utils';

export const getFormModel = (data?: any) => {
    return {
        BANKCODE: {
            value: data?.BANKCODE || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        BRANCH: {
            value: data?.BRANCH || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        PAYACCOUNT: {
            value: data?.PAYACCOUNT || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        CODE: {
            value: data?.CODE || '',
            error: '',
            validationRules: [handleRequiredError]
        },
        ACCNAME: {
            value: data?.ACCNAME || '',
            error: '',
            validationRules: [handleRequiredError]
        }
    };
};
